<template>
  <div class="container">
    <router-view /> <!-- 确保 router-view 在这里 -->
  </div>
</template>

<script>
import axios from 'axios';
import Cookies from 'js-cookie';

export default {
  created() {
    axios.interceptors.request.use((config) => {
      const token = Cookies.get('token');
      if (token) {
        config.headers['X-Auth-Token'] = `${token}`;
      }
      return config;
    }, (error) => {
      return Promise.reject(error);
    });

    // 添加响应拦截器
    axios.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      console.log(error)
      if (error.response && error.response.status === 403) {
        // 如果响应是403，跳转到登录页面
        this.$router.push('/login'); // 替换为你的登录页面路由
      }
      return Promise.reject(error);
    });
  },
};
</script>

<style>
.container {
  height: 100%;
}
</style>
